import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a >
            DEV STORY
          </a>{" "}
          2023
        </p>
      </div>
    </div>
  );
};

export default Footer;
